import React, { useEffect } from "react";
import SignOnchat from "../../components/signon/signonchat.index";
import SignOnlogo from "../../components/signon/signon.index";
import Footerlogo from "../../components/signon/footerlogo.index";
import "./signon.style.css";
import { Layout } from "antd";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/msalAuth/AuthProvider";
import Loader from "../../components/configure/Loader";
import { isValidRedirectPath } from "../../components/configure/utils";
import GenesysChat from "../../components/livechat/livechat";
// Campains
import { useMsal } from "@azure/msal-react";
import { Q_STORAGE_KEY } from "../../config/campaigns";

const { Content } = Layout;
const AUTO_LOGIN_ONCE = "sd_ask_autologin";

const SignOn = () => {
  const { isAuthenticated, login, loginNoPrompt } = useAuth();
  const { inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const storedPath = sessionStorage.getItem("sd_redirect");
    console.log("[signon] auth:", isAuthenticated, "| sd_redirect:", storedPath,
      "| valid:", storedPath && isValidRedirectPath(storedPath), "| at:", window.location.pathname);
    if (isAuthenticated) {
      if (storedPath && isValidRedirectPath(storedPath)) {
        navigate(storedPath, { replace: true });
      } else {
        navigate("/homepage", { replace: true });
      }
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (isAuthenticated || inProgress !== "none") return;
    if (!sessionStorage.getItem(Q_STORAGE_KEY)) return;
    if (sessionStorage.getItem(AUTO_LOGIN_ONCE)) return;
    sessionStorage.setItem(AUTO_LOGIN_ONCE, "1");
    const timer = setTimeout(() => {
      loginNoPrompt().catch(() => login());
    }, 500);
    return () => clearTimeout(timer);
  }, [isAuthenticated, inProgress, login, loginNoPrompt]);

  if (isAuthenticated) {
    return <Loader message="Loading..." />;
  }

  return (
    <Layout className="sgn-sandee-layout">
      <Header />
      <div className="sgn-background-shapes">
        <div className="sgn-shape sgn-shape-1"></div>
        <div className="sgn-shape sgn-shape-2"></div>
        <div className="sgn-shape sgn-shape-3"></div>
      </div>

      <Content className="sgn-sandee-content">
        <div className="sgn-main-wrapper">
          <SignOnlogo />
          <SignOnchat />
        </div>
        <Footerlogo />
      </Content>
      <GenesysChat />
    </Layout>
  );
};

export default SignOn;